import DialogCtn from './src/dialogctn.vue';

DialogCtn.install = function (Vue) {
    Vue.component(DialogCtn.name, DialogCtn);
};

export default DialogCtn;